var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1592",
    "data-name": "Group 1592",
    xmlns: "http://www.w3.org/2000/svg",
    width: 231.683,
    height: 26.961,
    viewBox: "0 0 231.683 26.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M314.48,148.8a53.818,53.818,0,0,1,8.094-.546c5.03,0,8.294.9,10.845,2.83,2.747,2.039,4.478,5.3,4.478,9.977,0,5.069-1.849,8.567-4.391,10.733-2.791,2.317-7.035,3.415-12.2,3.415a51.994,51.994,0,0,1-6.8-.4Zm6.01,21.612a11.111,11.111,0,0,0,2.083.117c5.42.039,8.957-2.927,8.957-9.269.039-5.5-3.181-8.406-8.328-8.406a12.56,12.56,0,0,0-2.712.234Z",
    transform: "translate(-314.48 -148.253)",
    fill: "#901f5d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M375.4,168.34l-1.9,6.8H367.31L375.4,148.66h7.854l8.211,26.481h-6.44l-2.044-6.8Zm6.718-4.479-1.649-5.62c-.488-1.571-.946-3.537-1.337-5.108h-.078c-.4,1.571-.785,3.576-1.22,5.108l-1.571,5.62Z",
    transform: "translate(-341.537 -148.459)",
    fill: "#901f5d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M422.413,153.7H415.3V148.66h20.344V153.7h-7.22V175.17h-6.01Z",
    transform: "translate(-366.114 -148.459)",
    fill: "#901f5d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M463.9,168.335l-1.883,6.8h-6.21L463.9,148.65h7.859l8.211,26.481h-6.44l-2.02-6.8Zm6.723-4.479-1.654-5.62c-.488-1.571-.942-3.537-1.337-5.108h-.078c-.39,1.571-.785,3.576-1.215,5.108l-1.576,5.62Z",
    transform: "translate(-386.861 -148.454)",
    fill: "#901f5d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M514.6,148.8a49.365,49.365,0,0,1,8.094-.546c3.693,0,6.342.707,8.094,2.122a7.718,7.718,0,0,1,2.829,6.128,8.45,8.45,0,0,1-2.439,6.288c-2.044,1.922-5.069,2.786-8.606,2.786a15.214,15.214,0,0,1-2.044-.117v9.469H514.6Zm5.932,12.011a9.242,9.242,0,0,0,2.005.156c3.181,0,5.147-1.61,5.147-4.322,0-2.439-1.688-3.9-4.674-3.9a10.3,10.3,0,0,0-2.478.234Z",
    transform: "translate(-416.97 -148.249)",
    fill: "#901f5d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M563.4,148.66h6.015v21.466h10.528v5.03H563.4Z",
    transform: "translate(-441.963 -148.459)",
    fill: "#901f5d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M611.193,168.335l-1.883,6.8H603.1l8.093-26.481h7.859l8.211,26.481h-6.44l-2.044-6.8Zm6.723-4.479-1.654-5.62c-.488-1.571-.941-3.537-1.332-5.108h-.083c-.39,1.571-.786,3.576-1.215,5.108l-1.571,5.62Z",
    transform: "translate(-462.295 -148.454)",
    fill: "#901f5d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M658.022,175.141V164.3L649.65,148.66h6.83l2.708,6.367c.825,1.922,1.376,3.337,2.044,5.069h.078c.59-1.654,1.22-3.186,2.005-5.069l2.674-6.367h6.718L663.983,164.1v11.04Z",
    transform: "translate(-486.135 -148.459)",
    fill: "#901f5d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M719.123,163.949h-9.757v6.288h10.9v4.908H703.37V148.66h16.343v4.913H709.38v5.5h9.757Z",
    transform: "translate(-513.647 -148.459)",
    fill: "#901f5d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M748.39,148.8a52.911,52.911,0,0,1,7.976-.546c3.9,0,6.679.585,8.562,2.078a6.735,6.735,0,0,1,2.439,5.542,7.03,7.03,0,0,1-4.679,6.523v.117c1.849.746,2.868,2.517,3.537,4.952.824,2.986,1.649,6.445,2.161,7.464H762.26a33.427,33.427,0,0,1-1.849-6.167c-.707-3.3-1.844-4.205-4.283-4.244h-1.8v10.411H748.39Zm5.932,11.4h2.356c2.986,0,4.757-1.493,4.757-3.81,0-2.439-1.654-3.654-4.391-3.693a14.97,14.97,0,0,0-2.708.2Z",
    transform: "translate(-536.704 -148.253)",
    fill: "#901f5d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logoName.79f61852.svg";
export { ForwardRef as ReactComponent };